export default async function getMenuData() {
  return [
    {
      category: true,
      title: 'Employee',
    },
    {
      title: 'Embedded steps',
      key: 'dashboardOnboarding',
      url: '/dashboard/onboarding',
      icon: 'fe fe-star',
    },
    {
      title: 'Embedded workflows',
      key: 'dashboardWorkflows',
      url: '/dashboard/workflows',
      icon: 'fe fe-check-circle',
    },
    {
      title: 'Workflow Progress',
      key: 'workflowProgress',
      url: '/dashboard/progress',
      icon: 'fe fe-list',
    },
    {
      title: 'Benefits',
      key: 'dashboardBenefits',
      url: '/dashboard/benefits',
      icon: 'fe fe-gift',
    },
    {
      title: 'Workspace',
      key: 'dashboardWorkspace',
      url: '/dashboard/workspace',
      icon: 'fe fe-lock',
    },
    {
      title: 'Send Invite',
      key: 'invite',
      url: '/dashboard/invite',
      icon: 'fe fe-mail',
    },
    {
      title: 'Cars Calculator',
      key: 'calculator',
      url: '/dashboard/cars-calculator',
      icon: 'fe fe-truck',
    },
    {
      title: 'Chattel Calculator',
      key: 'chattel-calculator',
      url: '/dashboard/chattel-calculator',
      icon: 'fe fe-dollar-sign',
    },
    {
      title: 'Promoted Benefits',
      key: 'proben',
      url: '/dashboard/promoted-benefits',
      icon: 'fe fe-credit-card',
    },
    {
      category: true,
      title: 'App Admin',
    },
    {
      title: 'Browser Testing',
      key: 'browserTesting',
      url: '/dashboard/browsertesting',
      icon: 'fe fe-smartphone'
    },
    {
      title: 'Profiles',
      key: 'profiles',
      url: '/dashboard/profiles',
      icon: 'fe fe-users'
    },
    {
      title: 'Demo users',
      key: 'demo-users',
      url: '/dashboard/demo-users',
      icon: 'fe fe-users'
    },
    {
      title: 'Workflows Theming',
      key: 'theming',
      url: '/dashboard/theming',
      icon: 'fe fe-code'
    }
  ]
}
